import { BREAK_POINT } from './helpers'
const _userAgent = navigator.userAgent.toLowerCase()

/**
 * wait
 */
export function wait(time) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

/**
 * throttle
 */
export function throttle(func, wait = 100) {
  let timer = null
  return function (...args) {
    if (timer === null) {
      timer = setTimeout(() => {
        func.apply(this, args)
        timer = null
      }, wait)
    }
  }
}

/**
 * isMobile
 */
export function isMobile() {
  // return window.innerWidth <= BREAK_POINT
  return window.matchMedia(`(max-width: ${BREAK_POINT}px)`).matches
}

/**
 * getBrowser
 */
export function getBrowser() {
  if (
    _userAgent.indexOf('msie') != -1 ||
    _userAgent.indexOf('trident') != -1
  ) {
    return 'ie'
  } else if (_userAgent.indexOf('edge') != -1) {
    return 'edge'
  } else if (_userAgent.indexOf('chrome') != -1) {
    return 'chrome'
  } else if (_userAgent.indexOf('safari') != -1) {
    return 'safari'
  } else if (_userAgent.indexOf('firefox') != -1) {
    return 'firefox'
  } else if (_userAgent.indexOf('opera') != -1) {
    return 'opera'
  } else {
    return 'unknown'
  }
}

/**
 * createUID
 */
export function createUID(v = '') {
  let result = ''
  const r = Math.floor(Math.random() * 8)

  ;[...Math.random().toString(36).slice(-8)].forEach((c) => {
    result += Math.random() >= 0.5 ? c.toUpperCase() : c
  })

  return `${result.slice(0, r)}${v}${result.slice(r)}`
}

/**
 * setCookie
 */
export function setCookie(expire_hour, name, value = 1) {
  const expire = new Date()
  expire.setTime(expire.getTime() + 1000 * 3600 * expire_hour)
  document.cookie = `${name}=${value}; expires=${expire.toUTCString()}`
}

/**
 * getCookie
 */
export function getCookie(name) {
  let result = null

  const cookieName = name + '='
  const allcookies = document.cookie

  const position = allcookies.indexOf(cookieName)
  if (position != -1) {
    const startIndex = position + cookieName.length

    let endIndex = allcookies.indexOf(';', startIndex)
    if (endIndex == -1) {
      endIndex = allcookies.length
    }

    result = decodeURIComponent(allcookies.substring(startIndex, endIndex))
  }

  return result
}
